import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import axios from "axios";
import { AuthProvider } from "src/App/context/AuthContext";
import ProtectedRoute from "src/App/components/ProtectedRoute";
import SignIn from "src/App/pages/SignIn";
import Home from "src/App/pages/Home";
import Reset from "src/App/pages/Reset";
import Dashboard from "src/App/pages/Dashboard";
import Admin from "src/App/pages/Admin";
import View from "src/App/pages/View";
import Footer from "src/App/components/Footer";
import About from "src/App/components/About";
import logo from "src/assets/logo.svg";
import { getWeatherTexts } from "./utils";
import "./app.scss";

const ipApiKey = "at_5fY4UpLc6Rj4hSW2bYmqNFvH3U3Ax";
const weatherApiKey = "e8ec9de421732b645a439f5bd7bf968f";

const BARE_ROUTES = ["/view", "/admin", "/dashboard"];

const AppInner = ({ data, texts }) => {
  const location = useLocation();
  const [aboutOpen, setAboutOpen] = useState(false);
  const isBare = BARE_ROUTES.some(r => location.pathname.startsWith(r));

  return (
    <div className="app-container">
      {!isBare && (
        <div className="page-logo">
          <img src={logo} alt="logo" />
        </div>
      )}
      <Routes>
        <Route path="/" element={<Home data={data} texts={texts} />} />
        <Route path="/login" element={<SignIn />} />
        <Route path="/reset" element={<Reset />} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute adminOnly>
            <Admin />
          </ProtectedRoute>
        } />
        <Route path="/view" element={<View />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!isBare && (
        <>
          <Footer setAboutOpen={setAboutOpen} />
          <About open={aboutOpen} onClose={() => setAboutOpen(false)} />
        </>
      )}
    </div>
  );
};

const App = () => {
  const [data, setData] = useState(null);
  const [texts, setTexts] = useState(null);

  useEffect(() => {
    const start = async () => {
      try {
        const response = await axios({
          url: "https://geo.ipify.org/api/v1",
          params: { apiKey: ipApiKey },
        });
        setData(response.data);
        const weatherResponse = await axios({
          url: "https://api.openweathermap.org/data/3.0/onecall",
          params: {
            lat: response.data.location.lat,
            lon: response.data.location.lng,
            exclude: "hourly,minutely",
            appid: weatherApiKey,
          },
        });
        setTexts([
          `I see you're in ${response.data?.location?.city}`,
          ...getWeatherTexts(weatherResponse.data),
        ]);
      } catch {
        // Non-critical — home page still renders without weather
      }
    };
    start();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <AppInner data={data} texts={texts} />
      </Router>
    </AuthProvider>
  );
};

export default App;
